import { useEffect, useContext } from 'react'
import { submissionContext } from '@contexts'
import { DraftsWithProvider } from '../drafts'

export const PendingAndDraftsContainer = () => {
  const { fetchDrafts } = useContext(submissionContext)

  useEffect(() => {
    fetchDrafts()
  }, [])

  return <DraftsWithProvider />
}
